import LayoutPadrao from 'lg-vue-components/layoutPadrao'
import ListarCriticasIntrajornadaVue from '../pages/criticasIntrajorda/ListarCriticasIntrajornada.vue'

export default [
  {
    path: '/',
    redirect: 'relatorios',
    component: LayoutPadrao,
    children: [
      {
        path: '/relatorios',
        name: 'relatorios',
        component: () => import('../pages/agendados/agendados.vue')
      }
    ]
  },
  {
    path: '/',
    redirect: 'relatorios',
    component: LayoutPadrao,
    children: [
      {
        path: '/relatorios-funcionarios',
        name: 'relatorios-funcionario',
        component: () => import('../pages/funcionarios/funcionarios.vue')
      }
    ]
  },
  {
    path: '/',
    redirect: 'jornada-trabalho',
    component: LayoutPadrao,
    children: [
      {
        path: '/relatorios-jornada-trabalho',
        name: 'relatorios-jornada-trabalho',
        component: () => import('../pages/jornadaTrabalho/JornadaTrabalho.vue')
      }
    ]
  },
  {
    path: '/',
    redirect: 'jornada-trabalho',
    component: LayoutPadrao,
    children: [
      {
        path: '/relatorios-historico-equipagem-trem',
        name: 'relatorios-historico-equipagem-trem',
        component: () => import('../pages/historicoEquipTrem/ListarHistoEquipTrem.vue')
      }
    ]
  },
  {
    path: '/',
    redirect: 'jornada-trabalho',
    component: LayoutPadrao,
    children: [
      {
        path: '/relatorios-atividades-excedentes',
        name: 'relatorios-atividades-excedentes',
        component: () => import('../pages/atividadesExcedentes/ListarAtividadesExcedentes.vue')
      }
    ]
  },
  {
    path: '/',
    redirect: 'jornada-trabalho',
    component: LayoutPadrao,
    children: [
      {
        path: '/relatorios-divergencia-ponto',
        name: 'relatorios-divergencia-ponto',
        component: () => import('../pages/divergenciaPonto/ListarDivergenciaPonto.vue')
      }
    ]
  },
  {
    path: '/',
    redirect: 'jornada-trabalho',
    component: LayoutPadrao,
    children: [
      {
        path: '/relatorios-criticas-intrajornada',
        name: 'relatorios-criticas-intrajornada',
        component: () => import('../pages/criticasIntrajorda/ListarCriticasIntrajornada.vue')
      }
    ]
  },
  {
    path: '/',
    redirect: 'jornada-trabalho',
    component: LayoutPadrao,
    children: [
      {
        path: '/relatorios-atividades',
        name: 'relatorios-atividades',
        component: () => import('../pages/atividadesRelatorio/ListarAtividadesRelatorio.vue')
      }
    ]
  },
  {
    path: '/',
    redirect: 'jornada-trabalho',
    component: LayoutPadrao,
    children: [
      {
        path: '/relatorios-adicionais',
        name: 'relatorios-adicionais',
        component: () => import('../pages/adicionais/ListarAdicionais.vue')
      }
    ]
  },
  {
    path: '/',
    redirect: 'jornada-trabalho',
    component: LayoutPadrao,
    children: [
      {
        path: '/relatorios-divergencias',
        name: 'relatorios-divergencias',
        component: () => import('../pages/divergencias/ListarDivergencias.vue')
      }
    ]
  },
  {
    path: '/',
    redirect: 'jornada-trabalho',
    component: LayoutPadrao,
    children: [
      {
        path: '/relatorios-criticas-atividade',
        name: 'relatorios-criticas-atividade',
        component: () => import('../pages/criticasAtividade/ListarCriticasAtividade.vue')
      }
    ]
  },
  {
    path: '/',
    redirect: 'jornada-trabalho',
    component: LayoutPadrao,
    children: [
      {
        path: '/relatorios-log-eventos',
        name: 'relatorios-log-eventos',
        component: () => import('../pages/logEventos/ListarLogEventos.vue')
      }
    ]
  },
  {
    path: '/',
    redirect: 'jornada-trabalho',
    component: LayoutPadrao,
    children: [
      {
        path: '/relatorios-diurnas-noturnas',
        name: 'relatorios-diurnas-noturnas',
        component: () => import('../pages/horasDiurnasNoturnas/ListarHorasDiurnasNoturnas.vue')
      }
    ]
  },
  {
    path: '/',
    redirect: 'jornada-trabalho',
    component: LayoutPadrao,
    children: [
      {
        path: '/relatorios-cerca-eletronica',
        name: 'relatorios-cerca-eletronica',
        component: () => import('../pages/cercaEletronica/ListarCercaEletronica.vue')
      }
    ]
  },
  {
    path: '/',
    redirect: 'reconhecimento-facial',
    component: LayoutPadrao,
    children: [
      {
        path: '/relatorios-reconhecimento-facial',
        name: 'relatorios-reconhecimento-facial',
        component: () => import('../pages/reconhecimentoFacial/ListarReconhecimentoFacial.vue')
      }
    ]
  }
]
